module.exports = __webpack_public_path__ + "99b1776ab203fd50b13a6d6cdcebbf94.png";